export default __webpack_public_path__ + "static/media/study1.7729e4ca.png";